(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', function () {
      var headers = document.querySelectorAll('[data-testid="hemming-header"]');

      headers.forEach(function (header) {
        var toggle = header.querySelector('[data-hemming-header-toggle]');
        var closeButton = header.querySelector('[data-hemming-header-close]');
        var mobileMenu = header.querySelector('[data-hemming-header-mobile]');

        var closeMenu = function () {
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
          }
          if (mobileMenu) {
            mobileMenu.hidden = true;
          }
          document.body.style.overflow = '';
        };

        var openMenu = function () {
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
          }
          if (mobileMenu) {
            mobileMenu.hidden = false;
          }
          document.body.style.overflow = 'hidden';
        };

        if (toggle && mobileMenu) {
          toggle.addEventListener('click', function () {
            var isOpen = toggle.getAttribute('aria-expanded') === 'true';
            if (isOpen) {
              closeMenu();
            } else {
              openMenu();
            }
          });
        }

        if (closeButton) {
          closeButton.addEventListener('click', closeMenu);
        }

        if (header.classList.contains('hemming-header--transparent')) {
          var pageWrapper = document.querySelector('.page-wrapper');

          var getScrollTop = function () {
            var windowScroll = window.scrollY || document.documentElement.scrollTop || 0;
            var wrapperScroll = pageWrapper ? pageWrapper.scrollTop : 0;
            return Math.max(windowScroll, wrapperScroll);
          };

          var updateScrollState = function () {
            var scrolled = getScrollTop() > 10;
            header.classList.toggle('is-scrolled', scrolled);
          };

          updateScrollState();
          window.addEventListener('scroll', updateScrollState, { passive: true });
          if (pageWrapper) {
            pageWrapper.addEventListener('scroll', updateScrollState, { passive: true });
          }

          document.documentElement.style.setProperty('--transparent-header-offset-boolean', '1');
        } else {
          document.documentElement.style.setProperty('--transparent-header-offset-boolean', '0');
        }

        var setHeaderHeightVar = function () {
          document.documentElement.style.setProperty('--header-group-height', header.offsetHeight + 'px');
        };

        setHeaderHeightVar();
        window.addEventListener('resize', setHeaderHeightVar);

        /* ---------------------------------------------------
           Desktop dropdown (click to open, closes others,
           forces the header to its solid colour state)
           --------------------------------------------------- */
        var desktopTriggers = header.querySelectorAll('[data-hemming-dropdown-trigger]');

        var closeAllDesktopDropdowns = function () {
          desktopTriggers.forEach(function (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            var panelId = trigger.getAttribute('data-target');
            var panel = document.getElementById(panelId);
            if (panel) {
              panel.classList.remove('is-open');
            }
          });
          header.classList.remove('is-dropdown-open');
        };

        desktopTriggers.forEach(function (trigger) {
          trigger.addEventListener('click', function (e) {
            e.stopPropagation();
            var panelId = trigger.getAttribute('data-target');
            var panel = document.getElementById(panelId);
            var isOpen = trigger.getAttribute('aria-expanded') === 'true';

            closeAllDesktopDropdowns();

            if (!isOpen && panel) {
              trigger.setAttribute('aria-expanded', 'true');
              panel.classList.add('is-open');
              header.classList.add('is-dropdown-open');
            }
          });
        });

        document.addEventListener('click', function (e) {
          if (!header.contains(e.target)) {
            closeAllDesktopDropdowns();
          }
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            closeAllDesktopDropdowns();
          }
        });

        /* ---------------------------------------------------
           Mobile inline dropdown (accordion within the
           mobile menu, tapping the "Shop" row expands it)
           --------------------------------------------------- */
        var mobileTriggers = header.querySelectorAll('[data-hemming-mobile-dropdown-trigger]');

        mobileTriggers.forEach(function (trigger) {
          trigger.addEventListener('click', function () {
            var panelId = trigger.getAttribute('data-target');
            var panel = document.getElementById(panelId);
            var isOpen = trigger.getAttribute('aria-expanded') === 'true';

            trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            if (panel) {
              panel.classList.toggle('is-open', !isOpen);
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hemming-best-sellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-testid="hemming-best-sellers"]').forEach(function (section) {
        section.querySelectorAll('[data-hemming-bs-media]').forEach(function (media) {
          media.addEventListener('click', function (event) {
            if (window.matchMedia('(hover: hover)').matches) {
              return;
            }
            var hasSecondary = media.querySelector('.hemming-best-sellers__image--secondary');
            if (hasSecondary && !media.classList.contains('is-swapped')) {
              event.preventDefault();
              media.classList.add('is-swapped');
            }
          });
        });

        section.querySelectorAll('[data-hemming-bs-wishlist]').forEach(function (button) {
          button.addEventListener('click', function () {
            var pressed = button.getAttribute('aria-pressed') === 'true';
            button.setAttribute('aria-pressed', String(!pressed));
          });
        });

        section.querySelectorAll('[data-hemming-bs-qty]').forEach(function (qty) {
          var input = qty.querySelector('.hemming-best-sellers__qty-input');
          var decrease = qty.querySelector('[data-hemming-bs-qty-decrease]');
          var increase = qty.querySelector('[data-hemming-bs-qty-increase]');

          if (decrease) {
            decrease.addEventListener('click', function () {
              var value = parseInt(input.value, 10) || 1;
              input.value = Math.max(1, value - 1);
            });
          }

          if (increase) {
            increase.addEventListener('click', function () {
              var value = parseInt(input.value, 10) || 1;
              input.value = value + 1;
            });
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hemming-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', function () {
      var headers = document.querySelectorAll('[data-testid="hemming-header"]');

      headers.forEach(function (header) {
        var toggle = header.querySelector('[data-hemming-header-toggle]');
        var mobileMenu = header.querySelector('[data-hemming-header-mobile]');

        if (toggle && mobileMenu) {
          toggle.addEventListener('click', function () {
            var isOpen = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', String(!isOpen));
            mobileMenu.hidden = isOpen;
            document.body.style.overflow = isOpen ? '' : 'hidden';
          });
        }

        if (header.classList.contains('hemming-header--transparent')) {
          var updateScrollState = function () {
            var scrolled = window.scrollY > 10;
            header.classList.toggle('is-scrolled', scrolled);
          };

          updateScrollState();
          window.addEventListener('scroll', updateScrollState, { passive: true });

          document.documentElement.style.setProperty('--transparent-header-offset-boolean', '1');
        } else {
          document.documentElement.style.setProperty('--transparent-header-offset-boolean', '0');
        }

        var setHeaderHeightVar = function () {
          document.documentElement.style.setProperty('--header-group-height', header.offsetHeight + 'px');
        };

        setHeaderHeightVar();
        window.addEventListener('resize', setHeaderHeightVar);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hemming-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-testid="hemming-product"]').forEach(function (section) {
        var mainImg = section.querySelector('.hemming-product__main-image img');
        var thumbs = section.querySelectorAll('[data-hemming-product-thumb]');

        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            thumbs.forEach(function (t) {
              t.classList.remove('is-active');
            });
            thumb.classList.add('is-active');

            if (mainImg) {
              var fullSrc = thumb.getAttribute('data-full-src');
              var fullSrcset = thumb.getAttribute('data-full-srcset');
              if (fullSrc) {
                mainImg.src = fullSrc;
              }
              if (fullSrcset) {
                mainImg.srcset = fullSrcset;
              }
            }
          });
        });

        var qtyWrapper = section.querySelector('[data-hemming-product-qty]');
        if (qtyWrapper) {
          var qtyInput = qtyWrapper.querySelector('[data-hemming-product-qty-input]');
          var decrease = qtyWrapper.querySelector('[data-hemming-product-qty-decrease]');
          var increase = qtyWrapper.querySelector('[data-hemming-product-qty-increase]');

          if (decrease) {
            decrease.addEventListener('click', function () {
              var value = parseInt(qtyInput.value, 10) || 1;
              qtyInput.value = Math.max(1, value - 1);
            });
          }
          if (increase) {
            increase.addEventListener('click', function () {
              var value = parseInt(qtyInput.value, 10) || 1;
              qtyInput.value = value + 1;
            });
          }
        }

        var jsonScript = section.querySelector('[data-hemming-product-json]');
        var variants = jsonScript ? JSON.parse(jsonScript.textContent) : [];
        var optionGroups = section.querySelectorAll('[data-hemming-product-option]');
        var variantIdInput = section.querySelector('[data-hemming-product-variant-id]');
        var priceEl = section.querySelector('product-price');
        var submitButton = section.querySelector('[data-hemming-product-submit]');
        var checkoutButton = section.querySelector('[data-hemming-product-checkout]');
        var submitLabel = section.querySelector('[data-hemming-product-submit-label]');

        var selectedOptions = [];
        optionGroups.forEach(function (group) {
          var selectedBtn = group.querySelector('.hemming-product__option-button.is-selected');
          selectedOptions.push(selectedBtn ? selectedBtn.getAttribute('data-value') : null);
        });

        function findVariant() {
          return variants.filter(function (variant) {
            return selectedOptions.every(function (value, index) {
              return value === null || variant.options[index] === value;
            });
          })[0];
        }

        function updateAvailability() {
          optionGroups.forEach(function (group, groupIndex) {
            var buttons = group.querySelectorAll('[data-hemming-product-option-value]');
            buttons.forEach(function (button) {
              var testOptions = selectedOptions.slice();
              testOptions[groupIndex] = button.getAttribute('data-value');
              var matching = variants.filter(function (variant) {
                return testOptions.every(function (value, index) {
                  return value === null || variant.options[index] === value;
                });
              });
              var anyAvailable = matching.some(function (variant) {
                return variant.available;
              });
              button.classList.toggle('is-unavailable', matching.length > 0 && !anyAvailable);
            });
          });
        }

        function updateForVariant() {
          var variant = findVariant();
          if (!variant) {
            return;
          }
          if (variantIdInput) {
            variantIdInput.value = variant.id;
          }
          if (priceEl) {
            var priceNode = priceEl.childNodes[0];
            if (priceNode) {
              priceNode.textContent = (variant.price / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD' });
            }
          }
          var available = variant.available;
          if (submitButton) {
            submitButton.disabled = !available;
          }
          if (checkoutButton) {
            checkoutButton.disabled = !available;
          }
          if (submitLabel) {
            submitLabel.textContent = available
              ? (submitLabel.getAttribute('data-available-label') || submitLabel.textContent)
              : (submitLabel.getAttribute('data-soldout-label') || 'Sold Out');
          }
          updateAvailability();
        }

        optionGroups.forEach(function (group, groupIndex) {
          var buttons = group.querySelectorAll('[data-hemming-product-option-value]');
          buttons.forEach(function (button) {
            button.addEventListener('click', function () {
              buttons.forEach(function (b) {
                b.classList.remove('is-selected');
              });
              button.classList.add('is-selected');
              selectedOptions[groupIndex] = button.getAttribute('data-value');

              var labelEl = group.querySelector('[data-hemming-product-option-label]');
              if (labelEl) {
                var optionName = labelEl.textContent.split(':')[0];
                labelEl.textContent = optionName + ': ' + button.getAttribute('data-value');
              }

              updateForVariant();
            });
          });
        });

        updateAvailability();

        var sizeGuideDialog = document.querySelector('[data-hemming-size-guide-dialog]');
        var sizeGuideOpen = section.querySelector('[data-hemming-size-guide-open]');
        var sizeGuideClose = sizeGuideDialog ? sizeGuideDialog.querySelector('[data-hemming-size-guide-close]') : null;

        if (sizeGuideOpen && sizeGuideDialog && typeof sizeGuideDialog.showModal === 'function') {
          sizeGuideOpen.addEventListener('click', function () {
            sizeGuideDialog.showModal();
          });
        }
        if (sizeGuideClose && sizeGuideDialog) {
          sizeGuideClose.addEventListener('click', function () {
            sizeGuideDialog.close();
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hemming-related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-testid="hemming-related"]').forEach(function (section) {
        section.querySelectorAll('[data-hemming-related-qty]').forEach(function (qty) {
          var input = qty.querySelector('.hemming-related__qty-input');
          var decrease = qty.querySelector('[data-hemming-related-qty-decrease]');
          var increase = qty.querySelector('[data-hemming-related-qty-increase]');

          if (decrease) {
            decrease.addEventListener('click', function () {
              var value = parseInt(input.value, 10) || 1;
              input.value = Math.max(1, value - 1);
            });
          }

          if (increase) {
            increase.addEventListener('click', function () {
              var value = parseInt(input.value, 10) || 1;
              input.value = value + 1;
            });
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hemming-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-testid="hemming-testimonials"]').forEach(function (section) {
        var track = section.querySelector('[data-hemming-testimonials-track]');
        var prevButton = section.querySelector('[data-hemming-testimonials-prev]');
        var nextButton = section.querySelector('[data-hemming-testimonials-next]');
        var dots = Array.prototype.slice.call(section.querySelectorAll('[data-hemming-testimonials-dot]'));

        if (!track) {
          return;
        }

        var slides = Array.prototype.slice.call(track.querySelectorAll('[data-hemming-testimonials-slide]'));
        if (slides.length === 0) {
          return;
        }

        var activeIndex = 0;
        var frame = null;

        function setActiveDot(index) {
          dots.forEach(function (dot, dotIndex) {
            dot.classList.toggle('is-active', dotIndex === index);
          });
        }

        function goTo(index) {
          var nextIndex = ((index % slides.length) + slides.length) % slides.length;
          activeIndex = nextIndex;
          var slide = slides[nextIndex];
          track.scrollTo({
            left: slide.offsetLeft - track.offsetLeft,
            behavior: 'smooth'
          });
          setActiveDot(nextIndex);
        }

        function updateActiveFromScroll() {
          if (frame) {
            window.cancelAnimationFrame(frame);
          }
          frame = window.requestAnimationFrame(function () {
            var center = track.scrollLeft + track.clientWidth / 2;
            var closestIndex = 0;
            var closestDistance = Infinity;
            slides.forEach(function (slide, index) {
              var slideCenter = slide.offsetLeft + slide.clientWidth / 2;
              var distance = Math.abs(center - slideCenter);
              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });
            if (closestIndex !== activeIndex) {
              activeIndex = closestIndex;
              setActiveDot(activeIndex);
            }
          });
        }

        if (prevButton) {
          prevButton.addEventListener('click', function () {
            goTo(activeIndex - 1);
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', function () {
            goTo(activeIndex + 1);
          });
        }

        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            goTo(parseInt(dot.getAttribute('data-index'), 10) || 0);
          });
        });

        track.addEventListener('scroll', updateActiveFromScroll, { passive: true });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
